import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{attrs:{"fluid":""}},[_c(VRow,_vm._l((_vm.fileIds),function(fileId,idx){return _c(VCol,{key:fileId,staticClass:"d-flex child-flex",attrs:{"cols":"12","sm":"6","md":"4","lg":"4","xl":"4"}},[_c('FilePreview',{attrs:{"fileId":fileId},on:{"click":_vm.onClick}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }